import { render } from "./portfolio_sidebar.html?vue&type=template&id=1a36c022&external"
import script from "./portfolio_sidebar.js?vue&type=script&lang=js&external"
export * from "./portfolio_sidebar.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__